export class TmsModuleNavigation {
    static get ActiveRoutes(): string { return 'app.tms.activeRoutes'; }
    static get ArrivalsBoard(): string { return 'app.tms.arrivalsBoard'; }
    static get History(): string { return 'app.tms.history'; }
    static get Scheduling(): string { return `app.tms.scheduling`; }
    static get EditSchedule(): string { return `${TmsModuleNavigation.Scheduling}.edit`; }
    static get NewSchedule(): string { return `${TmsModuleNavigation.Scheduling}.new`; }
    static get ImportSchedule(): string { return `${TmsModuleNavigation.Scheduling}.import`; }
    static get ScheduleView(): string { return `${TmsModuleNavigation.Scheduling}.view`; }
    static get RoutePerformance(): string { return 'app.tms.routeperformance'; }
    static get VisitPerformance(): string { return 'app.tms.visitperformance'; }

    static get Default(): string { return TmsModuleNavigation.ActiveRoutes; }
    static get ParentRoot(): string { return "app.tms"; }
}
